import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Token fallback storage – needed when third-party cookies are blocked
// (Safari ITP, Chrome 3PC restrictions on cross-domain prod ↔ api setups).
// Backend echoes access_token in /auth/login + /auth/accept-invite bodies;
// we mirror it into sessionStorage and send as Authorization: Bearer.
const TOKEN_KEY = "cbt:auth_token";

export const tokenStore = {
  get() {
    try {
      return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY) || "";
    } catch {
      return "";
    }
  },
  set(t) {
    try {
      // Persist in localStorage so a tab restore / mobile add-to-home survives.
      sessionStorage.setItem(TOKEN_KEY, t);
      localStorage.setItem(TOKEN_KEY, t);
    } catch { /* private mode */ }
  },
  clear() {
    try {
      sessionStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(TOKEN_KEY);
    } catch { /* noop */ }
  },
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((cfg) => {
  const t = tokenStore.get();
  if (t && !cfg.headers.Authorization) {
    cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

// On any 401 response (expired/missing session), bounce to /login – except for the
// /auth/me probe used by AuthProvider to determine if the user is logged in at all.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.includes("/auth/me") && !url.includes("/auth/login")) {
      tokenStore.clear();
      if (window.location.pathname !== "/login" && !window.location.pathname.startsWith("/accept-invite")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Noe gikk galt. Prøv igjen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
